import React from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'
import { openPopup } from '../../../store/popupSlice';

export default function OnDemandAllin() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="ondemand-allin-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ondemand-allin-head">
                <h3 className="heading center-heading"><span className="gradiant-color">All-in-One Platform </span> To Mobilize Your Community</h3>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="ondemand-allin-box">
                <div className="row align-items-center">
                  <div className="col-lg-7 col-md-6">
                    <img src="/assets/home/ondemand-allin-1.webp" alt="all in" className="img-responsive" />
                  </div>

                  <div className="col-lg-5 col-md-6">
                    <label>Unified Platform</label>
                    <span>Your branded all-in-one hub</span>
                    <p> Manage bookings, customer interactions, and service workflows from a single centralized platform. Designed to enable faster fulfillment, smoother user experiences, and consistent engagement across all on-demand services.</p>
                    <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn More</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="ondemand-allin-box">
                <div className="row align-items-center">
                  <div className="col-lg-5 col-md-6 order-1 order-md-0">
                    <label>Modular Systems</label>
                    <span>Customisable. Flexible. Scalable.</span>
                    <p>Configure platform features to match your specific on-demand business model. Whether supporting local services or large-scale operations, the system scales with demand while maintaining performance, stability, and operational control.</p>
                    <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn More</Link>
                  </div>

                  <div className="col-lg-7 col-md-6 order-0 order-md-1">
                    <img src="/assets/home/ondemand-allin-2.webp" alt="all in" className="img-responsive" />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="ondemand-allin-box">
                <div className="row align-items-center">
                  <div className="col-lg-7 col-md-6">
                    <img src="/assets/home/ondemand-allin-3.webp" alt="all in" className="img-responsive" />
                  </div>

                  <div className="col-lg-5 col-md-6">
                    <label>Future Forward</label>
                    <span>Focus on innovation</span>
                    <p>Leverage intelligent tools that automate processes, improve response times, enhance efficiency, and streamline operations. Evolve your on-demand offerings quickly and competitively without disrupting existing workflows.</p>
                    <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn More</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="ondemand-allin-box">
                <div className="row align-items-center">
                  <div className="col-lg-5 col-md-6 order-1 order-md-0">
                    <label>Real Support</label>
                    <span>Support with a human touch</span>
                    <p>Our dedicated support team works alongside you at every stage, ensuring reliable performance, rapid issue resolution, smooth integrations, and seamless scaling as your on-demand business grows globally.</p>
                    <Link onClick={() => dispatch(openPopup())} className="default-btn">Learn More</Link>
                  </div>

                  <div className="col-lg-7 col-md-6 order-0 order-md-1">
                    <img src="/assets/home/ondemand-allin-4.webp" alt="all in" className="img-responsive" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
